import React from 'react';

import { Paragraph, Text } from '@zillow/constellation';

import PeopleInformation from './PeopleInformation';
import { PERSON_TYPE } from '../../../constants/stringConstants';
import type { PeopleSection } from '../../../models/index';

type Props = {
  section: PeopleSection;
  setSection: (section: PeopleSection) => void;
  setSectionValues: (keyValuePairs: object) => void;
};

function TenantInformation_v2({ section, setSection, setSectionValues }: Props) {
  return (
    <>
      <Text fontType="h6">Tell us about your tenants</Text>
      <Paragraph marginBottom="sm">
        Add each tenant’s Zillow account email for signing the lease ({section.maxIndexedFieldsThatCanBeAdded} max). You
        can add non-signing occupants such as children later.
      </Paragraph>
      <PeopleInformation
        isOptional={false}
        personType={PERSON_TYPE.TENANT}
        setSectionValues={setSectionValues}
        setSection={setSection}
        section={section}
        addressLabel="Address for receiving notices prior to the lease’s start date"
      />
    </>
  );
}

TenantInformation_v2.description =
  'Tenant info component that dynamically determines max tenants based on what is reported by API';

export default TenantInformation_v2;
